export default function () {
  return {
    usuarios: null,
  };
}
